<template>
  <div class="ICodeIndex i18n" :class="(gameMode == CppOldMode ? 'backgroundColor': '')">
    <div class="header" id="header">
      <i class="IcodeIcon" />

      <div class="bounced" v-if="deviceType == 'pc'">
        <a href="https://mp.weixin.qq.com/s/CIHvIqq3QREey3BgrVdSzQ" v-if="$i18n.locale == 'zh'" target="_blank" >
          第八届ICode国际青少年编程竞赛中国区预选赛
        </a>
        <!-- <a href="./eventChristmas">
          <img src="~@/assets/images/event/Christmas2020/enterPic.png" v-if="$i18n.locale == 'zh'"/>
          <img src="~@/assets/images/event/Christmas2020/enterPic_EN.png" v-else/>
        </a> -->
        
      </div>
      
      <!-- 右下角图标 -->
      <!-- <div class="eventEntrance" v-if="$i18n.locale == 'zh'">
        <a href="https://challenge.ai.mgtv.com/#/track/21" target="_blank" v-if="$i18n.locale == 'zh' ">
          <img src="~@/assets/images/event/mgtv/02.png" width="100%;"/>
        </a>
      </div> -->

      <div class="header-btns clearfix">
        <div class="changeLangBtn" @click.stop="moreLang()">
          <img class="naviIcon" src="~@/assets/images/language.png">
          <span>
            {{ $t("language") }}
          </span>
          <ul
            v-show="changeLangBox"
            class="chooseLangUl"
          >
            <li
              v-for="(item, index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>

        <div class="modeSwitchBtn" @click.stop="modeSwitch()">
          
          <img class="naviIcon" v-if="gameMode == BlocklyMode" src="~@/assets/images/blocklyIcon.png">
          <img class="naviIcon" v-if="gameMode == PythonMode" src="~@/assets/images/pythonIcon.png">
          <img class="naviIcon" v-if="gameMode == CppMode" src="~@/assets/images/cppIcon.png">

          <span v-if="gameMode == BlocklyMode">{{ $t("Blockly") }}</span>
          <span v-if="gameMode == PythonMode">{{ $t("Python") }}</span>
          <span v-if="gameMode == CppMode">{{ $t("C++") }}</span>
          <span v-if="gameMode == CppOldMode">{{ $t("CppOldMode") }}</span>
          
          <ul class="chooseLangUl" v-show="modeSwitchBox">

            <li @click="switchMode(BlocklyMode)" v-if="gameMode != BlocklyMode ">{{ $t("index_txtSwitchToBlocky") }}</li>
            <li @click="switchMode(PythonMode)" v-if="gameMode != PythonMode">  {{ $t("index_txtSwitchToPython") }}</li>
            <li @click="switchMode(CppMode)" v-if="gameMode  != CppMode">    {{ $t("index_txtSwitchToCpp") }}   </li>
            <li @click="switchMode(CppOldMode)" v-if="gameMode  != CppOldMode">    {{ $t("SwitchToCppOldMode") }}   </li>
          </ul>
        </div>

        <div class="settingBtn" @click.stop="setting()">
          <img class="naviIcon" src="~@/assets/images/setting.png">
          <span>{{ userInfo.userName }} 
            <!-- <em class="iconfont icon-een"></em> -->
          </span>
          <ul class="chooseLangUl settingBtn-select" v-show="settingBoxVis">
            <li @click="toRace">{{ $t("myPageTitle") }}</li>
            <li @click="toMyAccount">{{ $t("setting_1") }}</li>

            <!-- 老师账号 -->
            <li v-if="classShow && userType === 2">
              <router-link to="/star" style="text-decoration: none">
                {{ $t("star_txt7") }}
              </router-link>
            </li>

            <!--学生账号 -->
            <li v-if="classShow && userType === 1 && $i18n.locale == 'zh'">
              <router-link to="/star" style="text-decoration: none">
                {{ $t("star_txt8") }}
              </router-link>
            </li>

            <li v-if="$i18n.locale == 'zh'">
              <a
                :href="$i18n.locale == 'zh' ? url.design : url.design_en"
                target="_blank"
                style="text-decoration: none"
              >
                {{ $t("index_txt48") }}
              </a>
            </li>

            <li @click="toCourseDes">
              {{ $t("course_explain") }}
            </li>

            <!-- <li v-if="$i18n.locale == 'zh'"><a 
            href="https://mp.weixin.qq.com/s/ATeIH-XtfTBNAm0gGsvFTg" 
            target="_blank"
            style="text-decoration: none"
            >{{ $t("releaseNotes") }}
            </a></li> -->

            <li @click="logOut">{{ $t("setting_2") }}</li>
            
          </ul>
        </div>

        <!-- <div class="actSign" v-if="channel.isLeap" @click="goToTrackGame()">
          {{ $t("enter_tech_btn") }}
        </div>

        <div
          class="actSign"
          v-if="channel.isStudyLeap"
          @click="goToTrackGame()"
        >
          {{ $t("enter_tech_study_btn") }}
        </div> -->

        <div class="dialog_9_div" v-show="!tipShow">
          <div class="blockly">
            <img
              src="~@/assets/images/dialog_9_1.png"
              width="200px"
              v-if="gameMode == BlocklyMode && $i18n.locale == 'zh'"
            />
            <img
              src="~@/assets/images/dialog_9_1_EN.png"
              width="200px"
              v-if="gameMode == PythonMode && $i18n.locale != 'zh'"
            />
          </div>
          <div class="python">
            <img id="dialog_9_2" width="200px"/>
          </div>
          <div class="btn">
            <img src="~@/assets/images/dialog_9_ok_EN.png" 
                 id = "dialog_9_ok"
                  width="100px" @click="closeDialogs(2)"/>
          </div>
        </div>
      </div>
    </div>

    <div class="mainBoxWrapper" @click="clickBox">
      <div class="mainBox" id="mainBox">
        <div v-show="gameMode < 3">
          <div class="upper-conBox clearfix">
            <div class="tableBox" :class="getFrame()">
              <div
                class="logo"
                :class="{
                  vip: vipLogo,
                }"
              >
                <!-- isEventAvatarVip: vipLogo,
                  isEventAvatar: isEventJoined, -->
                <img
                  class="avatorImg"
                  :src="userAvator.url"
                  width="126"
                  height="126"
                  @click="toMyAccount"
                />

                <p
                  class="titlesVip"
                  :class="{ courseTitleVip: userInfo.isVip == 1 }"
                >
                  {{ vipTextFilter(userInfo.isVip) }}
                </p>
              </div>

              <div class="icode icodeName">{{ userInfo.userName }}</div>
              <div class="icode icodeGrade">{{ gradeFilter(userInfo.grade) }}</div>

              <div class="icode icodeLevel" v-if="gameMode == BlocklyMode">{{ levelFilter(gameMode, userInfo.blockyLevel) }}</div>
              <div class="icode icodeLevel" v-if="gameMode == PythonMode">{{ levelFilter(gameMode, userInfo.pythonLevel) }}</div>
              <div class="icode icodeLevel" v-if="gameMode == CppMode">{{ levelFilter(gameMode, userInfo.cppLevel) }}</div>


              <div
                v-if="userInfo.isVip == 0"
                class="vipIcode"
                :class="{ isEventBoard: isEventJoined }"
                @click="becomeVip"
              >
                {{ vipTipsFilter(userInfo.isVip) }}
              </div>

              <el-tooltip
                v-if="userInfo.isVip == 1"
                class="item"
                effect="light"
                :content='$t("Expiry time: ") + vipTime'
                placement="top-end"
              >

                <div
                  class="vipIcode"
                  :class="{ isEventBoard: isEventJoined }"
                  @click="becomeVip"
                >
                  {{ vipTipsFilter(userInfo.isVip) }}
                </div>
              </el-tooltip>

            </div>

            <div class="myInfoBox">
              <div class="gameImgEn">
                <div class="block">
                  <el-carousel trigger="click" height="160px" :interval="1000000">
                    <el-carousel-item>
                      <span
                        v-html="$t('notice_lang1')"
                        v-if="$i18n.locale != 'he'"
                      ></span>
                      <span v-html="$t('notice_isr1')" v-else></span>
                    </el-carousel-item>

                    <el-carousel-item>
                      <span
                        v-html="$t('notice_lang2')"
                        v-if="$i18n.locale != 'he'"
                      ></span>
                      <span v-html="$t('notice_isr2')" v-else></span>
                    </el-carousel-item>

                    <el-carousel-item>
                      <span
                        v-html="$t('notice_lang3')"
                        v-if="$i18n.locale != 'he'"
                      ></span>
                      <span v-html="$t('notice_isr3')" v-else></span>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </div>

          <div class="lower-conBox clearfix">
            <div class="leftIcode">
              <span class="icodeTit">{{ $t("index_txt15") }}</span>

              <div class="arrows">
                <span class="pre" @click="pre" v-show="preShow"></span>
                <span class="next" @click="next" v-show="nextShow"></span>
              </div>

              <div class="planets">
                <ul class="planet">
                  <li
                    class="planetLis"
                    v-for="(item, index) in planetList"
                    @click="checkLi(item, index)"
                    :key="index"
                    :class="{ planetLisBg: item.locked }"
                  >
                    <div class="lisBgs"></div>

                    <div
                      class="planetLiss"
                      :class="'planetLis' + (index + 1)"
                    ></div>

                    <el-tooltip
                      class="item"
                      v-if="item.locked"
                      effect="light"
                      :content=' $t("Require level {level} pass to unlock.", {level: gameLevelFilter(item.id)})'
                      placement="top-end"
                    >
                      <i class="bgIcon"></i>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </div>

            <div
              class="rightIcode"
              v-loading="courseListShow"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 43, 70, 0.8)"
            >
              <div class="tipsIcode">{{ $t("Welcome to Training ground: Level {level}", {level: gameLevelFilter(tipsText)}) }}</div>

              <span
                class="allArrows preIcode"
                @click="preIcode"
                v-if="preIcodeShow"
              ></span>
              <span
                class="allArrows nextIcode"
                @click="nextIcode"
                v-if="nextIcodeShow"
              ></span>

              <div class="course">
                <div v-if="false" class="noCourseTxt">
                  <div>{{ $t("no_data_course_txt_0") }}</div>
                  <div>{{ $t("no_data_course_txt_1") }}</div>
                </div>

                <ul class="courseUl">
                  <li
                    class="courseLis"
                    v-for="(course, index) in courseList"
                    :key="index"
                  >
                    <div
                      class="courseTitle"
                      :class="{ courseTitleVip: course.gameType == 6 }"
                    >
                      {{ courseFilter(course) }}
                    </div>

                    <img :src="getCourseICon(course.gameId, course.gameType)" class="courseImg"/>

                    <div class="courseScorce">
                      {{ course.userScore }}/{{ course.totalScore }}
                    </div>

                    <div
                      class="courseStart"
                      @click="startLearn(course)"
                    >
                      <span>{{ $t("index_txt20") }}</span>
                    </div>

                    <el-tooltip
                      class="course"
                      v-if="course.locked"
                      effect="light"
                      :content="$t('index_txt37')"
                      placement="top-end"
                    >
                      <i class="bgIcon"></i>
                    </el-tooltip>
                  </li>
                </ul>
              </div>

              <div class="learnMsg">
                <div class="progressBar" v-if="progress_max != 0">
                  <el-progress :percentage="progress_length" color="#33d3dd" />
                  <!-- v-if="progressStarHover === true" -->

                  <div class="progressStarMain">
                    <i
                      class="progressStar"
                      :style="barStyle"
                      @mouseover="progressStarHover = true"
                      @mouseout="progressStarHover = false"
                    >
                      <section
                        class="progressMsg"
                        v-show="progressStarHover === true"
                        v-html="
                          $t('course_unlocktxt1') +
                            ' ' +
                            progressStar_lockPoint +
                            ' ' +
                            $t('course_unlocktxt2')
                        "
                      ></section>
                    </i>
                  </div>

                </div>

                <span class="progress_txt">
                  {{ progress_current }}/{{ progress_max }}
                </span>

                <div class="raceGoBtn" v-if="ysList.length != 0 && $i18n.locale != 'he'">
                  <span @click="raceGo">{{ $t("raceGo") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Cpp" v-if="gameMode == CppOldMode">
          <div class="CppContent">
            <div class="CppMaterial" >
              <img :src="userAvator.url" alt="">
              <div class="CppUserInfo" >
                <!-- <div v-if="userInfo.userName.length > 5">
                  <el-tooltip class="item" effect="dark" :content="userInfo.userName" placement="top">
                    <div style="max-width: 140px; width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{userInfo.userName}}</div>
                  </el-tooltip>
                </div>
                <div v-else style="max-width: 140px; width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{userInfo.userName}}</div> -->
                <div style="max-width: 200px; width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{userInfo.userName}}
                </div>
                <div>{{ gradeFilter(userInfo.grade) }}</div>
              </div>
            </div>
            <div class="CppBulletin">
              <p class="bulletTitle">{{$t("index_cpp")}}</p>
              <div class="bulletContent">
                <p>{{$t('index_icode_cpp')}}</p>
              </div>
            </div>
          </div>
          <div class="courseList">
            <p style="width:775px;font-size:36px;font-weight:bold;text-align:center;">课程列表</p>
            <div class="pack">
              <div ref="courseItem" class="courseItem" @mouseout="mouseoutBox(index)" @mouseover="mouseoverBox(index)" v-for="(item,index) in arr" :key="index">
                <div class="courseItems">
                  <img v-if="item.status == 1" style="border-top-left-radius:10px;border-top-right-radius:10px;" :src="vip == 0 ? item.notVipUrl :item.vipUrl" @click="vipToCpp(item.cGameId,item.status)" alt="">
                  <img v-else style="border-top-left-radius:10px;border-top-right-radius:10px;" :src="item.notOpenUrl" @click="vipToCpp(item.cGameId,item.status)" alt="">
                  <div class="introduce">
                    <p style="font-size:10px;color:#595757;height:49px;padding:0 10px;text-indent: 15px">{{item.introduce}}</p>
                    <el-progress v-if="Math.floor(item.successTaskCount / item.totalTaskCount * 100) != 0 && item.status != 0 " :color="customColor" style='width:340px;margin:-10px auto;' :text-inside="true"  :stroke-width="15" :percentage="Math.floor(item.successTaskCount / item.totalTaskCount * 100)?Math.floor(item.successTaskCount / item.totalTaskCount * 100):0"></el-progress>
                  </div>
                </div>
              </div>
              <div class="runDialog">
                <el-dialog
                    title=""
                    :visible.sync="runCenterDialogVisible"
                    center>
                  <img @click="runCenterDialogVisible = false" src="../assets/cancle.png" alt="">
                  <div class="text">成为正式宇航员即可开启</div>
                  <span slot="footer" class="dialog-footer">
<!--                        <el-button @click="runCenterDialogVisible = false">返回</el-button>-->
                        <el-button type="primary" @click="newOpen">立即开通</el-button>
                      </span>
                </el-dialog>
              </div>
              <div class="noOpen">
                <el-dialog
                    title=""
                    :visible.sync="centerDialogVisible"
                    center>
                  <img @click="centerDialogVisible = false" src="../assets/cancle.png" alt="">
                  <div class="text">该课程暂未开放</div>
                  <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="centerDialogVisible =  false">返回</el-button>
                      </span>
                </el-dialog>
              </div>
            </div>
            <div class="CppFooter">
              <el-pagination
                  layout="prev, pager, next"
                  :page-size="pagesize"
                  :total="total"
                  :background="true"
                  @current-change="handleCurrentChange"
                  @next-click="nextClick"
                  @prev-click="prevClick">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>


    <el-dialog
      :visible.sync="if_Freshman_Visible"
      :close-on-click-modal="false"
      :show-close="false"
      class="chooseMode"
      width="900px"
      center
    >
      <div class="container">
        <div class="title">
          <h2>{{ $t("Please select a programming mode") }}</h2>
        </div>

        <div class="tip">
          <b>{{$t("The robot Dev is in trouble")}}</b>
        </div>

        <div class="btn">
          <section>
            <div
              class="btn-blocky"
              @click="handleMode(0)"
            ></div>
            <div
              class="btn-python"
              @click="handleMode(1)"
            ></div>
          </section>

          <section class="btn_text">
            <div class="btn-blocky__text">
              {{ $t("freshMan_blocky_text") }}
            </div>
            <div class="btn-python__text">
              {{ $t("freshMan_python_text") }}
            </div>
          </section>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="if_Instruction_Visible"
      :close-on-click-modal="false"
      :show-close="false"
      class="chooseMode"
      width="900px"
      center
    >
      <div class="container">
        <div class="title">
          <h2>{{$t("Would you like to watch the instruction video?")}}</h2>
        </div>

        <div class="tip">
          <b>{{$t("using the ICode platform for the first time")}}</b>
        </div>

        <div class="btn">
          <div
            class="btn-closeInstruction"
            @click="closeInstructionVideo()">
            <span>
              {{ $t("Skip") }}
            </span>
          </div>
          <div
            class="btn-playInstruction"
            @click="playInstructionVideo()">
            <span>
              {{ $t("Play") }}
            </span>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="if_unlockTrain_Visible"
      :close-on-click-modal="false"
      :show-close="false"
      class="unlockTrain"
      width="600px"
      center
    >
      <div class="container">
        <div class="title">
          <h2>{{$t("unlocked a new level")}}</h2>
        </div>

        <div class="tip">
          <span>{{$t("Go explore more new knowledge!")}}</span>
        </div>

        <i class="closeBtn" @click="if_unlockTrain_Visible = false"></i>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="if_IE_hint_Visible" width="600px">
      <span>{{ $t("broswer1") }}</span>
      <div slot="footer" class="dialog-footer" align="center">
        <a target="_blank" :href="url.chromeWin">{{ $t("broswer2") }}</a>
        &nbsp;&nbsp;
        <a target="_blank" :href="url.chromeWin64">{{ $t("broswer3") }}</a>
        &nbsp;&nbsp;
        <a target="_blank" :href="url.macWin">{{ $t("broswer4") }}</a>
      </div>
    </el-dialog>

    <div class="videoWrapper" v-if="PreVideoShow">
      <video :src="staticDomain + 'assets/game/static/video/' + $i18n.locale + '/video01.mp4'"
        autoplay
      >
      </video>
      <!-- <iframe v-else width="100%" height="100%" 
        src="https://www.youtube.com/embed/hQU2ZG-zPY0?autoplay=1" 
        title="ICode Starter" frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowfullscreen>
      </iframe> -->
      
      <div class="btn">
        <img
          src="~@/assets/images/unlockbtn.png"
          width="40px"
          @click="closeDialogs(1)"
        />
      </div>
    </div>

    <LeapPopup
      v-if="maskBox"
      @onOK="logOut"
      :title="$t('timeout01')"
      :content="$t('timeout02')"
      :cancelButtonTxt="$t('timeout04')"
      :okButtonTxt="$t('timeout03')"
      :isConfirm="false"
    ></LeapPopup>

    <LeapPopup
      v-if="final2024popup"
      @onConfirm="go2024"
      @onCancel="final2024popup = false"
      title="恭喜你"
      content="恭喜您，您已经获得2024年中国区决赛资格，点击确认前往报名参赛。中国区决赛将于7月13-14日在全国15个城市举办，您可以选择你最喜欢的地点前往。"
      :cancelButtonTxt="$t('timeout04')"
      :okButtonTxt="$t('timeout03')"
      :isConfirm="true"
    ></LeapPopup>
  </div>
</template>

<script>
import store from "../store";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
import ChannelMedia from "@/utils/ChannelMedia";
import RetCode from "@/data/RetCode";
import MediaUtils from "@/utils/MediaUtils";
import GameType from "../data/GameType";
import LeapPopup from "./LeapPopup";
import I18nUtils from "@/utils/i18nUtils";
import { getIDEurl } from "@/utils/domain";

export default {
  data() {
    return {
      centerDialogVisible:false,
      runCenterDialogVisible:false,
      vip:'',
      vipUrl:'',
      total:0,
      pagesize:4,
      customColor:'#2D5DCC',
      GO_cpp:'',
      //C++ 模式下的课程列表
      arr:[],
      preShow: false,
      nextShow: true,
      // 课程list 左右按钮 隐藏/显示
      preIcodeShow: false,
      nextIcodeShow: true,
      // 课程list 有无数据
      // 我的班级 隐藏/显示
      classShow: false,
      courseListShow: true,

      coursesStatusMap: {}, // gameid: 0/1 课程开关情况，无配置则认为是开启 
      // planetVlue: "0",

      // const
      BlocklyMode: 0,
      PythonMode: 1,
      CppMode: 2,
      CppOldMode: 10,

      planetList: [
        { id: 0, name: "1级", locked: false },
        { id: 10, name: "2级", locked: true },
        { id: 20, name: "3级", locked: true },
        { id: 30, name: "4级", locked: true },
        { id: 40, name: "5级", locked: true },
        { id: 50, name: "6级", locked: true },
      ],
      // 横向课程列表
      courseList: [],

      // 机构课程列表：
      orgCourseList: [],

      // 训练场的切换标记
      index: 0,
      // 横向课程列表的切换标记
      indexCourse: 0,

      // 多语言切换
      changeLangBox: false,
      settingBoxVis: false,
      modeSwitchBox: false,
      // 比赛(课程)列表
      ysList: [],
      ysTime: "",
      // nav栏语言选择
      langList: I18nUtils.langList,
      // 保存用户相关数据
      userInfo: {
        userName: "",
        grade: "",
        isVip: 0,
        pythonLevel: "",
        blockyLevel: "",
        cppLevel: "",
        raceGameId: "",
        mode: "",
        orgId: 0,
        orgIsValid: 0
      },
      // IE提示弹窗
      if_IE_hint_Visible: false,
      deviceType: "pc",

      // 新人选择学习模式弹窗
      if_Freshman_Visible: false,

      // 新人教学视频弹窗
      if_Instruction_Visible: false,

      // 训练场解锁弹窗
      if_unlockTrain_Visible: false,

      // 升级提示
      progressStarHover: false,

      // 训练场的星球等级
      planetId: parseInt(localStorage.getItem("planetId")) || 0,

      /**
       * 课程模式
       * 0 - Blockly
       * 1 - Python
       * 2 - Cpp
       * 10 - CppOld
       */
      gameMode: 0,

      //tipShow true为不显示，false为显示
      tipShow: true,
      userId: null,
      PreVideoShow: false,

      // vip期限时间
      vipTime: "",
      vipLogo: false,

      tipsText: "0",
      numl: "",
      weekGameTimeTxt: "",
      channel: ChannelMedia.getInstance(),
      url: {
        // 如果常规访问则不变，不然跳转英文版
        design: MediaUtils.getDesignURL(1),
        design_en: MediaUtils.getDesignURL(2),
        chromeWin: MediaUtils.getChrome(1),
        chromeWin64: MediaUtils.getChrome(2),
        macWin: MediaUtils.getDesignURL(3),
      },

      // 试用账号标记
      isTrailAccount: false,
      // 参加活动标记（修改部分img）
      isEventJoined: false,

      // 学习进度条、第一个是进度条显示百分比
      progress_length: 0,
      progress_current: "",
      progress_max: "",

      progressStar_lockPoint: 0,

      blocklyLockPoint: {
        level1: 60,
        level2: 60,
        level3: 60,
        level4: 60,
        level5: 60,
      },
      pythonLockPoint: {
        level1: 60,
        level2: 60,
        level3: 60,
        level4: 60,
        level5: 60,
      },

      serverLocation: "",
      staticDomain: MediaUtils.getStaticDomain(),
      final2024popup: false,
    };
  },

  components: {
    LeapPopup,
  },

  created(){
    this.$http.getAxios.get('c/course/getCGameList?page=1&size=4').then(res=>{
      if(res.data.code == 0){
        this.arr =res.data.data.data
        this.total = res.data.data.cGameCount
      }
    })
    this.GO_cpp = process.env.GO_CPP
  },

  mounted() {
    // 判断是否是移动浏览器
    if (MediaUtils.isMobileBrowser()) {
      let mainBox = document.getElementById("mainBox");
      mainBox.style.transform = "scale(.6)";
      mainBox.style.position = "absolute";
      mainBox.style.top = "-130px";
      mainBox.style.left = "-220px";

      this.deviceType = "mobile";
    }

    // 检查、更换平台语言版本
    I18nUtils.initLanguage(this);

    // 获取用户数据
    this.queryUserInfo();
    this.getWeekTime();

    this.getServerLocation();

    // let lisBg = document.querySelectorAll(".lisBgs");
    // lisBg[0].classList.add("lisBg");
  },

  methods: {
    check2024final() {
      if(new Date() > new Date(2024, 6, 1)) { return }

      let popupCnt = localStorage.getItem("final2024popup_" + this.userId);
      popupCnt = popupCnt == null ? 0 : parseInt(popupCnt);
      if(popupCnt >= 3) return;

      this.$http
        .getAxios("event/getEventUser", {
          method: "get",
          params: {
            eventCode: 240554, // 资格检查
          },
        }).then((res) => {
          if(res.data && res.data.code == 0){ // 有资格
            // 检查是否已经报名
            this.$http
              .getAxios("event/getEventUser", {
                method: "get",
                params: {
                  eventCode: 240555, // 是否已经报名
                },
              })
              .then((res) => {
                if(res.data && res.data.code == 0){ // 已经报名
                    return; 
                } else {
                  this.final2024popup = true;
                  localStorage.setItem("final2024popup_" + this.userId, popupCnt+1);
                }
              })

          } else {
            return; // 无资格
          }

        });
    },

    go2024() {
      this.final2024popup = false;
      window.open("https://c.icode.org.cn/2024", '_blank');
    },

    getFrame() {
      if (this.userInfo.isVip == 0) {
        if (this.userInfo.mode == 0) {
          return "normal_" + this.userInfo.blockyLevel;
        }
        else {
          return "normal_" + this.userInfo.pythonLevel;
        }
      }
      else {
        if (this.userInfo.mode == 0) {
          return "vip_" + this.userInfo.blockyLevel;
        }
        else {
          return "vip_" + this.userInfo.pythonLevel;
        }
      }
    },
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },

    getServerLocation(){
      this.$http.getAxios.get("foo/getArea").then((res) => {
            this.serverLocation = res.data;
        });
    },
    
    newOpen(){
      this.$router.push("/wechat")
      this.runCenterDialogVisible = false
    },
    vipToCpp(cGameId,status){
      if(status == 1){
        if(this.vip == 1){
          let CppUrl=`${this.GO_cpp}/?cGameId=${cGameId}`
          window.open(CppUrl);
        }else{
          this.runCenterDialogVisible = true
        }
      }else{
          this.centerDialogVisible = true
      }
    },
    mouseoutName(){

    },
    mouseoverName(){

    },
    nextClick(val){
      this.getCGameList(val)
    },
    prevClick(val){
      this.getCGameList(val)
    },
    handleCurrentChange(val){
      this.getCGameList(val)
    },
    getCGameList(val){
      this.$http.getAxios.get('c/course/getCGameList?page='+val+'&size=4').then(res=>{
        if(res.data.code == 0){
          this.arr =res.data.data.data
        }
      })
    },
    mouseoverBox(i){
      this.$refs.courseItem[i].style = 'border: 2px solid #6B8CDB;border-radius:10px'
    },
    mouseoutBox(i){
      this.$refs.courseItem[i].style = 'border: 2px solid #F6F5FA; border-radius:10px'
    },

    // 播放教学视频
    playInstructionVideo() {
      this.if_Instruction_Visible = false;
      this.toCourseDes();

    },

    // 关闭教学视频
    closeInstructionVideo() {
      this.if_Instruction_Visible = false;

    },

    // 关闭tip 和 视频
    closeDialogs(val) {
      this.$http.getAxios
        .get("/user/closeTips", {
          params: {
            type: val,
          },
        })
        .then((res) => {
          const _res = res.data;
          if (_res.code == 0) {
            if (val == 1) {
              this.PreVideoShow = false;
            } else if (val == 2) {
              this.tipShow = true;
            }
          } else {
            throw new Error("错误:" + _res.code);
          }
        });
    },

    async getOrgGameList() {
      let res = await this.$http.getAxios("/org/getOrgGameList");

      if (res.data.code == "0") {
        this.orgCourseList = res.data.data;
      }
    },

    isOrgCourse(gameId) {
      if(this.userInfo.orgId == 0 || this.userInfo.orgIsValid == 0) return false;
      return this.orgCourseList.find(course => course && course.gameId == gameId);
    },

    //获取竞赛信息
    async queryUserInfo() {
      try {
        let res = await this.$http.getAxios("/user/queryUserInfo");
        // code=0 -> 用户登录成功
        if (res.data.code == "0") {
          // 设置 tipShow
          this.userId = res.data.data.userId;
          this.vip = res.data.data.isVip;
          this.tipShow = res.data.data.showTips;
          
          if(this.$i18n.locale == "he"){
            this.PreVideoShow = !res.data.data.showVideo;  // 播放视频, 定义的逻辑反了
          }

          // 机构注册有效期是否到期
          if (res.data.data.orgIsValid == 1) {
            this.classShow = true;
          } else {
            this.classShow = false;
          }

          // 检测是否选择过初始模式
          if (res.data.data.gameMode === undefined) { 
            this.if_Freshman_Visible = true;
          } else {
            this.if_Freshman_Visible = false;
            // 存储、设置用户的学习模式
            // mode用于表示课程类型，一共有两种课程类型
            // mode=0：blocky课程；mode=1：python课程
            localStorage.setItem("modes", res.data.data.gameMode);
            this.gameMode = res.data.data.gameMode;
            this.getCourseMsg(res.data.data.gameMode, this.planetId);
          }


          // vip过期时间
          this.vipTime = this.format(
            parseInt(res.data.data.vipExpireTime + "000")
          );

          // 判断训练课程的解锁状态
          this.userInfo = {
            userName: res.data.data.firstName,
            grade: res.data.data.grade,
            blockyLevel: res.data.data.blockGameLevel,
            pythonLevel: res.data.data.gameLevel,
            cppLevel: res.data.data.cppGameLevel,
            isVip: res.data.data.isVip,
            mode: res.data.data.gameMode,
            orgId: res.data.data.orgId, // 机构信息
            orgIsValid: res.data.data.orgIsValid,

          };

          // 刷新页面统计是否达到新等级训练场 需要psgMsg.mode
          // this.checkNewTrain();

          // 设置训练课程的解锁状态
          this.planetList.forEach((e) => {
            if (this.gameMode == this.BlocklyMode) {
              if (Number(res.data.data.blockGameLevel) >= e.id) {
                e.locked = false;
              }
            }
            if (this.gameMode == this.PythonMode) {
              if (Number(res.data.data.gameLevel) >= e.id) {
                e.locked = false;
              }
            }
            if (this.gameMode == this.CppMode) {
              if (Number(res.data.data.cppGameLevel) >= e.id) {
                e.locked = false;
              }
            }
          });

          // 判断用户是否为VIP
          if (res.data.data.isVip == 1) {
            this.vipLogo = true;
          }

          // 设置用户的头像
          this.userAvator.id = res.data.data.pictureId;
          this.userAvator.url = res.data.data.pictureUrl;

          // 试用账号判定
          if (res.data.data.isVip === 0 && res.data.data.mobile === "") {
            this.isTrailAccount = true;
          }

          // 存储作用暂时不明
          this.$store.commit("toggleMaskState", false);
          this.$store.commit("setUserType", res.data.data.userType);
          this.$store.commit("setUserName", this.userInfo.userName);
          localStorage.setItem("userType", res.data.data.userType);
          localStorage.setItem("names", this.userInfo.userName);

          // 默认点击
          for(let i=0; i<this.planetList.length; i++) {
            let item  = this.planetList[i];
            if(item.id == this.planetId) {
              this.checkLi(item, i);
              break;
            }
          }
        }
        // code=5 -> 获取用户信息缺失
        else if (res.data.code == "5") {
          this.$router.push({ path: "/signIn" });
          return;
        }
        // code=others -> 获取到未知code值将会直接返回登录首页
        else {
          this.$router.push({ path: "/" });
          return;
        }
      } catch (err) {
        console.log(err);
      }

      await this.getUserCoursesStatus(); 
      // this.check2024final();
    },

    // 用户课程开关情况
    async getUserCoursesStatus() {

      if(this.userType != 1) return; // 非学生不考虑
      if(!this.classShow) return; // 无班级不考虑

      let res = await this.$http.getAxios("/class/getUserClassList");
      if(res.data && res.data.code == '0'){
        // 无班级信息
        if(res.data.data == undefined) return;

        let classInfo = res.data.data[0]; // 第一个即班级信息
        if(classInfo && classInfo.courses) {
          this.coursesStatusMap = JSON.parse(classInfo.courses); // 从API获取课程列表
        } 

        // 当且仅当videoOpen为false时关闭，其他情况默认打开
        let classSettingVideo = classInfo.videoOpen == false ? "closed" : "open";
        Cookies.set("classSettingVideo", classSettingVideo, {
          domain: MediaUtils.getCookieDomain(),
          path: "/",
          expires: 7,
        });
        
      } else {
        this.$message({
          type: "Error",
          message: "获取班级信息失败",
        });
      }
    },

    async getWeekTime() {
      // let res = await this.$http.getAxios("/week/game/getWeekGameTime", {
      //   method: "post",
      // });
      // if (res.data.code == RetCode.SUCCESS) {
      //   let value = res.data.data["startTimeCn"];
      //   if (this.$i18n.locale != "zh") {
      //     value = res.data.data["startTimeEn"];
      //   }
      // this.weekGameTimeTxt = this.$t("index_txt210") + value;
      this.weekGameTimeTxt = this.$t("index_txt210");
      // return;
      // }
      // this.weekGameTimeTxt = "";
    },

    // 判断周赛是否在时间显示
    checkIsFirstEnterWeek() {
      // if (this.planetVlue > 0) {
      //   return;
      // }
      if (this.ysList.length <= 0) {
        this.weekGameTimeTxt = "";
        return;
      }
      let gameObj = this.ysList[0];
      if (gameObj.weekGameExpireTime > 0) {
        this.getWeekTime();
        return;
      }
      this.weekGameTimeTxt = this.$t("week_game_tips");
    },

    /**
     * @description 获取教材信息
     * @param mode 0：blocky
     * @param mode 1：python
     */
    async getCourseMsg(mode, level) {
      try {
        let res = await this.$http.getAxios("/user/getGameList", {
          method: "post",
          data: {
            mode,
            level,
          },
        });
        const _res = res.data;

        if (_res.code == 0) {
          this.courseListShow = false;

          this.progress_current = _res.data.star;
          this.progress_max = _res.data.totalStar;

          this.progress_length = Math.round(100 * Math.pow((this.progress_current/this.progress_max), 0.5));

          // 课程列表
          let list = _res.data.gameInfoList;

          if (list && list.length > 0) {
            // 初始化可用课程
            let count = 0;

            // 课程类型 详见【data/GameType.js】
            list.forEach((e, i) => {
              if (
                e.gameType == GameType.MONTH_GAME ||
                e.gameType == GameType.WEEK_GAME_TYPE ||
                e.gameType == GameType.MONTH_COST
              ) {
                this.ysList.push(e);
                list.splice(i, 1);
              }

              // 非中文下，综合2锁定
              let course = e;
              if((course.gameId == '10012' || course.gameId == '100120' || course.gameId == '20012') && this.$i18n.locale == 'he' && !this.userInfo.isVip) {
                course.locked = true;
              }

              if (e.useable == 0) {
                // 单项课程的锁状态
                e.locked = true;
              } else {
                count++;
              }

              if (e.gameType == 3) {
                let sTime = this.format(e.startTimestamp * 1000);
                let fTime = sTime.slice(0, 10) + " " + sTime.slice(11, 16);
                this.ysTime = fTime;
                sessionStorage.setItem("ysTime", fTime);
              }
            });

            list = list.filter(course => this.coursesStatusMap[course.gameId] !== 0 ); // 过滤班级关闭的课程

            // 如果机构课程可用的话
            if(!this.userInfo.isVIP && this.userInfo.orgId && this.userInfo.orgIsValid) {
              await this.getOrgGameList();
              if(this.orgCourseList && this.orgCourseList.length > 0) {
                list = list.filter(course => this.isOrgCourse(course.gameId) || course.useable == 1); // 过滤机构课程
                list.forEach(course => course.locked = false);
              }
            };
            this.courseList = list;

            if (this.courseList.length <= 3) {
              this.nextIcodeShow = false;
            } else {
              this.nextIcodeShow = true;
            }

            // // 插入等级赛的gameId
            if (this.ysList.length > 0) {
              this.userInfo.raceGameId = this.ysList[0].gameId;
            }
            if(level == 0){
              this.userInfo.raceGameId = mode == 0? 8001 : 8002;
            } else {
              const d = new Date();
              this.userInfo.raceGameId = 
                (d.getFullYear() - 2000) * 10000
                + (d.getMonth() + 1) * 100
                + mode * 10 + parseInt(level/10) + 1;

            }

            this.$nextTick(() => {
              this.numl = document.querySelectorAll(".courseLis");
              let btn = document.querySelectorAll(".courseStart");

              this.courseList.forEach((e, i) => {
                if (e.gameType == 6) {
                  this.numl[i].classList.add("courseLisVip");
                  btn[i].classList.add("courseBtnVip");

                  if (this.gameMode === this.BlocklyMode) {
                    btn[i].classList.add("courseBtnVip__blocky");
                  }
                }
              });
            });
            this.checkIsFirstEnterWeek();
          } else {
            // 如果没有数据
            this.nextIcodeShow = false;
          }
        } else {
          this.$notify.error({
            title: "错误",
            message: "错误码：GM-err-" + _res.code + "。请联系ICode管理员。",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 积木/python模式控制器
    handleMode(val) {
      localStorage.setItem("modes", val);

      this.$http.getAxios
        .get("/user/chooseMode", {
          params: {
            mode: val,
          },
        })
        .then((res) => {
          const _res = res.data;
          if (_res.code == 0) {
            // 设置训练场的课程解锁状态。flag：true表示不可用
            switch (val) {
              case 0: {
                for (let i = 0; i < this.planetList.length; i++) {
                  if (
                    Number(this.userInfo.blockyLevel) >= this.planetList[i].id
                  ) {
                    this.planetList[i].locked = false;
                  } else {
                    this.planetList[i].locked = true;
                  }
                }
                  this.$message.success({
                    message: this.$t("You're in blockly mode now!"),
                    duration: 3000,
                  });
      
                break;
              }
              case 1: {
                for (let i = 0; i < this.planetList.length; i++) {
                  if (
                    Number(this.userInfo.pythonLevel) >= this.planetList[i].id
                  ) {
                    this.planetList[i].locked = false;
                  } else {
                    this.planetList[i].locked = true;
                  }
                }
                this.$message.success({
                  message: this.$t("You're in python mode now!"),
                  duration: 3000,
                });

                break;
              }
              case 2: {
                for (let i = 0; i < this.planetList.length; i++) {
                  if (
                    Number(this.userInfo.cppLevel) >= this.planetList[i].id
                  ) {
                    this.planetList[i].locked = false;
                  } else {
                    this.planetList[i].locked = true;
                  }
                }
                this.$message.success({
                  message: this.$t("You're in C++ mode now!"),
                  duration: 3000,
                });

                break;
              }
              case 10:
              {

                this.$message.success({
                  message: this.$t("You're in C++ mode now!"),
                  duration: 3000,
                });

                break;
              }

            }
            this.getCourseMsg(val, this.planetId);
            this.if_Freshman_Visible = false;

            // 希伯来语跳过视频
            if(this.$i18n.locale != "he"){
              this.if_Instruction_Visible = true;
            }
            
          }
          // 刷新缓存
          this.queryUserInfo();
        });
    },

    // 积木/python模式控制器
    handleModeAgain(val) {
      localStorage.setItem("modes", val);

      this.$http.getAxios
        .get("/user/chooseMode", {
          params: {
            mode: val,
          },
        })
        .then((res) => {
          const _res = res.data;
          if (_res.code == 0) {
            // 设置训练场的课程解锁状态。flag：true表示不可用
            switch (val) {
              case 0: {
                for (let i = 0; i < this.planetList.length; i++) {
                  if (
                    Number(this.userInfo.blockyLevel) >= this.planetList[i].id
                  ) {
                    this.planetList[i].locked = false;
                  } else {
                    this.planetList[i].locked = true;
                  }
                }

                this.$message.success({
                  message: this.$t("You're in blockly mode now!"),
                  duration: 3000,
                });

                break;
              }
              case 1: {
                for (let i = 0; i < this.planetList.length; i++) {
                  if (
                    Number(this.userInfo.pythonLevel) >= this.planetList[i].id
                  ) {
                    this.planetList[i].locked = false;
                  } else {
                    this.planetList[i].locked = true;
                  }
                }

                this.$message.success({
                  message: this.$t("You're in python mode now!"),
                  duration: 3000,
                });

                break;
              }
              case 2: {
                for (let i = 0; i < this.planetList.length; i++) {
                  if (
                    Number(this.userInfo.cppLevel) >= this.planetList[i].id
                  ) {
                    this.planetList[i].locked = false;
                  } else {
                    this.planetList[i].locked = true;
                  }
                }

                this.$message.success({
                  message: this.$t("You're in C++ mode now!"),
                  duration: 3000,
                });

                break;
              }
              case 10:
              {

                this.$message.success({
                  message: this.$t("You're in C++ mode now!"),
                  duration: 3000,
                });
                break;
              }
            }
            this.getCourseMsg(val, this.planetId);
            this.if_Freshman_Visible = false;
          }
          // 刷新缓存
          this.queryUserInfo();
        });
    },
    // 支持handleMode的功能控件
    switchMode(gameMode) {
      this.courseListShow = true;
      this.courseList = [];
      this.ysList = [];
      this.indexCourse = 0;
      this.preIcodeShow = false;
      var oul = document.querySelector(".courseUl");
      this.animate(oul, { left: 0 }, function() {});

      this.gameMode = gameMode;
      this.handleModeAgain(gameMode);
      // this.checkNewTrain();
    },

    // 检测用户当前级别&模式来判断是否解锁新等级训练场
    checkNewTrain() {
      try {
        this.$http.getAxios
          .get("/user/getLevelUpStatus", {
            params: {
              mode: this.userInfo.mode,
            },
          })
          .then((res) => {
            const _res = res.data;
            if (_res.code == 0) {
              // BE原话：status：0和2不需要弹框， 1 弹框
              if (_res.data.status == 1) {
                // 刷新训练场锁状态
                this.queryUserInfo();
                this.$forceUpdate();

                this.if_unlockTrain_Visible = true;
              }
            }
          });
      } catch (e) {
        console.log(e);
      }
    },

    checkLi(item, index) {
      if (item.locked) return;
      this.planetVlue = item.id;
      this.tipsText = item.id;
      this.courseListShow = true;
      this.courseList = [];
      this.ysList = [];
      this.indexCourse = 0;
      this.preIcodeShow = false;
      var oul = document.querySelector(".courseUl");
      this.animate(oul, { left: 0 }, function() {});
      let lisBg = document.querySelectorAll(".lisBgs");
      lisBg.forEach((e) => {
        e.classList.remove("lisBg");
      });
      lisBg[index].classList.add("lisBg");

      this.planetId = item.id;
      localStorage.setItem("planetId", this.planetId);

      this.getCourseMsg(this.gameMode, this.planetId);
    },

    // 活动页面
    events(val) {
      localStorage.setItem("eventNo", val);
      switch (val) {
        // 圣诞节活动
        case 1225: {
          this.$router.push({ path: "/eventChristmas" });
          break;
        }
      }
    },

    getCourseICon(gameId, type) {
      try {
        return require(`../assets/images/course/${type==6?"vip/":""}courseImg${gameId}.png`);
      } catch (e) {
        return require(`../assets/images/course/${type==6?"vip/":""}default.png`);
      }
    },

    // 进入游戏按钮
    startLearn(val) {
      if (val.locked) return;
      this.goCode(val.gameId);
    },


    // 进入游戏
    goCode(gameId) {
      var ua = navigator.userAgent.toLocaleLowerCase();
      if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
        this.if_IE_hint_Visible = true;
      } else {
        Cookies.set("language", this.$i18n.locale, {
          path: "/",
          domain: MediaUtils.getCookieDomain(),
          expires: 7,
        });
        this.$http
          .getAxios("/user/enterGame", {
            method: "post",
            data: { mode: this.gameMode, gameId },
          })
          .then((res) => {
            var res = res.data;
            if (res.code == RetCode.SUCCESS) {
              let urls = `${getIDEurl()}?highLevel=1&mode=${this.gameMode}&game=${gameId}&language=${this.$i18n.locale}`;

              urls += this.$i18n.locale == 'he' ? "&cl=ISRHome" : "";

              // 增加用户信息传递
              urls += this.userType == 2 ? "&userType=2" : "";

              window.location.href = urls;
              return;

            } else if (res.code == "119") {
            this.$notify.error({
              title: this.$t("ERROR"),
              message: this.$t("Sorry, you can't play the game. Please contact the admin for info."),
            });

            } else if (res.code == "122") {
                this.$notify.error({
                  title: this.$t("ERROR"),
                  message: this.$t("Sorry, the race doesn't exist. Please contact the admin for info."),
                });

            } else if (res.code == "123") {
                this.$notify.error({
                  title: this.$t("ERROR"),
                  message: this.$t("Sorry, the race is not configured. Please contact the admin for info."),
                });
            }

            if (res.code == RetCode.ORG_EXPIRED) {
              this.$message.error("学校版课程已过期");
              return;
            }
            
            if (res.code == RetCode.NOT_OPEN) {
              this.$message.error(this.$t("ret_coe_txt_49"));
              return;
            }
            if (res.code == RetCode.NOT_OPEN) {
              this.$message.error(this.$t("ret_coe_txt_49"));
              return;
            }
            this.$message.error(this.$t("can_not_enter_txt"));
          });
      }
    },

    goToTrackGame() {
      this.gameMode = this.channel.mode;
      this.goCode(this.channel.trackId);
    },
    
    // 训练场切换支持
    pre() {
      this.nextShow = true;
      var oul = document.querySelector(".planet");
      var numl = document.querySelectorAll(".planetLis");
      var wid = 160;
      if (this.index > 0) {
        this.index--;
        if (this.index == 0) {
          this.preShow = false;
        } else {
          this.preShow = true;
        }
      } else {
        this.preShow = false;
      }
      this.animate(oul, { top: -wid * this.index }, function() {});
    },
    next() {
      this.preShow = true;
      var oul = document.querySelector(".planet");
      var numl = document.querySelectorAll(".planetLis");
      var wid = 160;
      if (this.index == numl.length - 2) {
        this.nextShow = false;
      } else {
        this.nextShow = true;
        this.index++;
        if (this.index == numl.length - 2) {
          this.nextShow = false;
        }
      }
      this.animate(oul, { top: -wid * this.index }, function() {});
    },
    // 训练场课程切换支持
    preIcode() {
      this.nextIcodeShow = true;
      var oul = document.querySelector(".courseUl");
      // wid移动距离
      var wid = 184;
      if (this.indexCourse > 0) {
        this.indexCourse--;
        if (this.indexCourse == 0) {
          this.preIcodeShow = false;
        } else {
          this.preIcodeShow = true;
        }
      } else {
        this.preIcodeShow = false;
      }
      this.animate(oul, { left: -wid * this.indexCourse }, function() {});
    },
    nextIcode() {
      this.preIcodeShow = true;
      var oul = document.querySelector(".courseUl");
      var numl = document.querySelectorAll(".courseLis");
      var wid = 184;
      if (this.indexCourse == numl.length - 3) {
        this.nextIcodeShow = false;
      } else {
        this.nextIcodeShow = true;
        this.indexCourse++;
        if (this.indexCourse == numl.length - 3) {
          this.nextIcodeShow = false;
        }
      }
      this.animate(oul, { left: -wid * this.indexCourse }, function() {});
    },
    //原生js动画类似jquery--animate
    animate(obj, styleJson, callback) {
      clearInterval(obj.timer);
      // 开启定时器
      obj.timer = setInterval(() => {
        var locked = true; //假设所有动作都已完成成立。
        for (var styleName in styleJson) {
          //1.取当前属性值
          var iMov = 0;
          // 透明度是小数，所以得单独处理
          iMov = parseInt(this.getStyles(obj, styleName));
          //2.计算速度
          var speed = 0;
          speed = (styleJson[styleName] - iMov) / 5; //缓冲处理，这边也可以是固定值
          speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed); //区分透明度及小数点，向上取整，向下取整

          //3.判断是否到达预定值
          if (styleJson[styleName] != iMov) {
            locked = false;
            if (styleName == "opacity") {
              //判断结果是否为透明度
              obj.style[styleName] = (iMov + speed) / 100;
              obj.style.filter = "alpha(opacity:" + (iMov + speed) + ")";
            } else {
              obj.style[styleName] = iMov + speed + "px";
            }
          }
        }
        if (locked) {
          //到达设定值，停止定时器，执行回调
          clearInterval(obj.timer);
          if (callback) {
            callback();
          }
        }
      }, 30);
    },
    //获取对象样式规则信息，IE下使用currentStyle
    getStyles(obj, style) {
      return getComputedStyle(obj, false)[style];
    },

    moreLang() {
      this.changeLangBox = !this.changeLangBox;
      this.settingBoxVis = false;
      this.modeSwitchBox = false;
    },

    // 点击关闭header的按钮弹窗
    clickBox() {
      this.changeLangBox = false;
      this.settingBoxVis = false;
      this.modeSwitchBox = false;
    },
    // header按钮控制
    setting() {
      this.settingBoxVis = !this.settingBoxVis;
      this.changeLangBox = false;
      this.modeSwitchBox = false;
    },
    // 模式切换按钮控制
    modeSwitch() {
      this.modeSwitchBox = !this.modeSwitchBox;
      this.changeLangBox = false;
      this.settingBoxVis = false;
    },
    // 一些跳转
    becomeVip() {
      // 以色列服务器，跳转到付费页面
      if(this.serverLocation=='israel' || this.$i18n.locale == "he"){
        window.open("https://icodeisrael.com/#courses", '_blank');
        return;
      }
      this.$router.push({ path: "/wechat" });
    },

    toRace() {
      this.$router.push({ path: "/myPage" });
    },

    raceGo() {
      this.$router.push({
        path: "/monthly",
        query: {
          g: this.userInfo.raceGameId,
          m: this.userInfo.mode,
          level: this.planetId,
        },
      });
    },
    toMyAccount() {
      // 保存用户头像链接
      this.$store.commit("saveUserAvator", this.userAvator);

      this.$router.push({ path: "/myAccount" });
    },
    toCourseDes() {
      window.open(process.env.COURSE_URL);
    },
    // 登出
    logOut() {
      this.$http
        .getAxios("/user/logout", {
          method: "post",
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            this.channel.clear(); //清空数据
            store.commit("toggleMaskState", false);

            sessionStorage.removeItem("gameId");
            sessionStorage.removeItem("level");

            this.$router.push({ path: "/" });
          }
        });
    },
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    format(t) {
      //t是整数，否则要parseInt转换
      var time = new Date(t);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var hours = time.getHours();
      var minutes = time.getMinutes();
      var seconds = time.getSeconds();

      return (
        y +
        "-" +
        this.add0(m) +
        "-" +
        this.add0(d) +
        " " +
        this.add0(hours) +
        ":" +
        this.add0(minutes) +
        ":" +
        this.add0(seconds)
      );
    },
    getEnterButtonGameTxt() {
      if (this.ysList.length <= 0) {
        return "";
      }
      if (this.ysList[0].gameType == 9) {
        return this.$t("week_enter_txt_btn");
      }
      return this.$t("index_txt22");
    },
    gradeFilter(status) {
      const statusMap = {
        0: this.$t("grade0"),
        1: this.$t("grade1"),
        2: this.$t("grade2"),
        3: this.$t("grade3"),
        4: this.$t("grade4"),
        5: this.$t("grade5"),
        6: this.$t("grade6"),
        7: this.$t("grade7"),
        8: this.$t("grade8"),
        9: this.$t("grade9"),
        10: this.$t("grade10"),
        11: this.$t("grade11"),
        12: this.$t("grade12"),
        13: this.$t("grade13")
      };
      return statusMap[status];
    },
    // 主面板等级过滤
    levelFilter(gameMode, level) {
      const gameModeMap = {
        0: this.$t("blockly_level", {level: this.gameLevelFilter(level)}),
        1: this.$t("Python_level", {level: this.gameLevelFilter(level)}),
        2: this.$t("Cpp_level", {level: this.gameLevelFilter(level)}),
      };
      return gameModeMap[gameMode];
    },
    // 主面板的等级配置
    gameLevelFilter(level) {
      const statusMap = {
        0: 1,
        10: 2,
        20: 3,
        30: 4,
        40: 5,
        50: 6,
      };
      return statusMap[level];
    },

    courseFilter(course) {
      let courseName = this.$t("index_course_" + course.gameId);
      if(courseName == "index_course_" + course.gameId) {
        return course.gameName;
      }
      return courseName;
    },

    vipTextFilter(status) {
      const statusMap = {
        0: this.$t("index_txt9"),
        1: this.$t("index_txt10"),
      };
      return statusMap[status];
    },

    vipTipsFilter(status) {
      if (this.orgCourseList.length > 0) {
        return "学校版账号";
      }
      const statusMap = {
        0: this.$t("index_txt11"),
        1: this.$t("index_txt12"),
      };
      return statusMap[status];
    },
  },

  computed: {
    ...mapGetters(["maskBox", "name", "userType", "userAvator"]),

    lan() {
      return this.$i18n.locale;
    },

    barStyle() {
      let style = {};
      let per = 0;

      if (this.userInfo.mode == 0) {
        switch (this.planetId) {
          // 一级
          case 0: {
            this.progressStar_lockPoint = this.blocklyLockPoint.level1;
            per = Math.round(
              (this.blocklyLockPoint.level1 / this.progress_max) * 100
            );
            break;
          }
          // 二级
          case 10: {
            this.progressStar_lockPoint = this.blocklyLockPoint.level2;
            per = Math.round(
              (this.blocklyLockPoint.level2 / this.progress_max) * 100
            );
            break;
          }
          // 三级
          case 20: {
            this.progressStar_lockPoint = this.blocklyLockPoint.level3;
            per = Math.round(
              (this.blocklyLockPoint.level3 / this.progress_max) * 100
            );
            break;
          }
          // 四级
          case 30: {
            this.progressStar_lockPoint = this.blocklyLockPoint.level4;
            per = Math.round(
              (this.blocklyLockPoint.level4 / this.progress_max) * 100
            );
            break;
          }
          // 五级
          case 40: {
            // style.display = "none";
            this.progressStar_lockPoint = this.blocklyLockPoint.level5;
            per = Math.round(
              (this.blocklyLockPoint.level5 / this.progress_max) * 100
            );
            break;
          }
          // 六级
          case 50: {
            style.display = "none";
            this.progressStar_lockPoint = this.blocklyLockPoint.level5;
            per = Math.round(
              (this.blocklyLockPoint.level6 / this.progress_max) * 100
            );
            break;
          }
          default:
            throw new Error("blockly level 未定义");
        }
      }

      if (this.userInfo.mode == 1) {
        switch (this.planetId) {
          // 一级
          case 0: {
            this.progressStar_lockPoint = this.pythonLockPoint.level1;
            per = Math.round(
              (this.pythonLockPoint.level1 / this.progress_max) * 100
            );
            break;
          }
          // 二级
          case 10: {
            this.progressStar_lockPoint = this.pythonLockPoint.level2;
            per = Math.round(
              (this.pythonLockPoint.level2 / this.progress_max) * 100
            );
            break;
          }
          // 三级
          case 20: {
            this.progressStar_lockPoint = this.pythonLockPoint.level3;
            per = Math.round(
              (this.pythonLockPoint.level3 / this.progress_max) * 100
            );
            break;
          }
          // 四级
          case 30: {
            // style.display = "none";

            this.progressStar_lockPoint = this.pythonLockPoint.level4;
            per = Math.round(
              (this.pythonLockPoint.level4 / this.progress_max) * 100
            );
            break;
          }
          // 五级
          case 40: {
            // style.display = "none";

            this.progressStar_lockPoint = this.pythonLockPoint.level5;
            per = Math.round(
              (this.pythonLockPoint.level5 / this.progress_max) * 100
            );
            break;
          }
          // 六级
          case 50: {
            style.display = "none";

            this.progressStar_lockPoint = this.pythonLockPoint.level5;
            per = Math.round(
              (this.pythonLockPoint.level5 / this.progress_max) * 100
            );
            break;
          }
          default:
            throw new Error("python level 未定义");
        }
      }

      if (this.userInfo.mode >= 2) {
        this.progressStar_lockPoint = this.pythonLockPoint.level1;
        per = Math.round((60 / this.progress_max) * 100);
      }

      per = Math.sqrt(per*100) - 5;
      style.left = per + "%";
      return style;
    },
  },
};
</script>

<style lang="scss">
.ICodeIndex {
  .header {
    height: 60px;
    font-size: 20px;
    line-height: 60px;
    padding-left: 30px;
    color: #aaf9fe;
    background: #122346;

    .eventEntrance {
      position: fixed; 
      width:150px; 
      right: 50px; 
      bottom: 50px; 
      z-index: 999;
      animation: textAction 1.5s linear infinite;
      transition: all 1s ease;
      cursor: pointer;
    }

    .IcodeIcon {
      position: absolute;
      top: 8px;
      left: 40px;
      width: 172px;
      height: 46px;
      cursor: pointer;
      z-index: 200;
      background: url("~@/assets/images/bigIcon.png") center / contain no-repeat;
    }

    .christmas {
      position: absolute;
      left: 300px;
      width: 350px;
      height: 60px;
      background: url("~@/assets/images/event/Christmas2020/enterPic.png")
        center / contain no-repeat;
      cursor: pointer;

      &_EN {
        background-image: url("~@/assets/images/event/Christmas2020/enterPic_EN.png");
      }
    }
    .bounced {
      position: absolute;
      top: 8px;
      left: 350px;
      line-height: 36px;
      font-size: 24px;
      font-weight: bold;
      color: #ffec44;
      cursor: pointer;
      z-index: 200;
      animation: textAction 1.5s linear infinite;

      a {
        text-decoration: none;
      }
    }

    @media (max-width: 1200px) {
      .bounced {
          display: none;
      }
    }

    &-btns {
      position: absolute;
      top: 0;
      right: 20px;
      height: 60px;
      z-index: 200;
    }
    .modeSwitchBtn,
    .settingBtn,
    .changeLangBtn {
      cursor: pointer;
      float: right;
      font-size: 18px;
      padding-right: 20px;
      .naviIcon {
        width: 24px;
        height:24px;
        vertical-align: middle;
      }
    }
    .settingBtn {
      padding-right: 0px;
      margin-right: 20px;
      position: relative;
      min-width: 150px;
      text-align: center;

      &-select {
        width: 100%;
      }
    }
    .dialog_9_div {
      position: fixed;
      top: 70px;
      right: 70px;
      width: 200px;
      height: 150px;
      transform: translate(-10%, 0);
      cursor: default;

      .btn {
        position: absolute;
        bottom: 0;
        left: 50px;
        width: 100px;
        line-height: inherit;
        img {
          cursor: pointer;
        }
      }
    }
    .actSign {
      position: relative;
      margin: 0 20px;
      float: right;
      cursor: pointer;

      &-joinGame {
        position: absolute;
        display: block;
        height: 100%;
        width: 100%;
      }
    }
    .ys {
      background: url("~~@/assets/images/ysZh.png") center / cover no-repeat;
    }
    .ysEn {
      background: url("~~@/assets/images/ysEn.png") center / cover no-repeat;
    }
    .mycomEn {
      background: url("~~@/assets/images/mycomEn.png") center / cover no-repeat;
    }
    .actSignEn {
      background: url("~~@/assets/images/enUp.png") center / cover no-repeat;
    }
    .chooseLangUl {
      background: #0c355c;
      padding: 5px;
      border-radius: 5px;
      overflow: hidden;
      z-index: 201;

      li {
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        transition: 0.2s ease all;

        &:hover {
          color: #fffc51;
          background: #092a49;
        }
      }
    }
  }

  .mainBox {
    width: 1200px;
    position: relative;
    margin: 0 auto;
    .Cpp{
      margin-top: 40px;
      display:flex;
      .CppContent{
        .CppMaterial{
          width: 360px;
          height:225px;
          font-size:20px;
          background-color: #FFFFFF;
          border-radius: 10px;
          display: flex;
          box-shadow:0px 0px 8px #9E9F9F;
          img{
            width:150px;
            height:150px;
            margin-top: 30px;
            margin-left: 20px;
            margin-right: 25px;
          }
          .CppUserInfo{
            margin-top: 40px;
            line-height:50px;
          }
        }
        .CppBulletin{
          width:360px;
          //height:530px;
          background-color: #FFFFFF;
          border-radius: 10px;
          margin-top: 30px;
          box-shadow:0px 0px 8px #9E9F9F;
          padding-bottom:30px;
          .bulletTitle{
            text-align: center;
            font-size:28px;
            font-weight: bold;
            color:#E72D66;
            padding-top: 20px;
          }
          .bulletContent{
            margin: 0 20px;
            p{
              padding-top: 20px;
              margin: 20px auto;
              font-size:18px;
            }
          }
        }
      }
      .courseList{
        margin-left: 65px;
        width:775px;
        height:885px;
        .pack{
          width:100%;
          height: 645px;
          display:flex;
          //justify-content:space-around;
          flex-wrap:wrap;
          //align-content:space-around;
          //align-content:stretch;
          //align-content: space-around;
          margin-top: 30px;
          .courseItem{
            height:310px;
            margin-bottom:25px;
            margin-left: 12px;
            .courseItems{
              width:365px;
              height:310px;
              border-radius: 10px;
              background-color: #FFFFFF;
              img{
                width:100%;
              }
              .introduce{
                height:calc(310px - 217.4px);
                margin-top: -3px;
                padding:20px 5px;
                .el-progress-bar__inner{
                  line-height:0;
                }
              }
            }
          }
          .runDialog{
            .el-dialog__wrapper{
              position:absolute;
              top:calc(50% - 300px);
              left:calc(50% - 200px);
            }
            .el-dialog{
              background: url("../assets/back.png");
              width:350px;
              height:200px;
            }
            .el-button{
              height:30px;
              width:120px;
              line-height:5px;
              font-size:16px;
              font-weight:bold;
            }
            .el-dialog__footer{
              position: absolute;
              left:0;
              right:0;
              bottom: -10px;
            }
            .el-dialog__headerbtn{
              display:none;
            }
            img{
              position: absolute;
              top:15px;
              right:15px
            }
            .text{
              position: absolute;
              left:15%;
              top: 15px;
              font-size:21px;
              font-weight: bold;
            }
          }
          .noOpen{
            .el-dialog__wrapper{
              position:absolute;
              top:calc(50% - 300px);
              left:calc(50% - 200px);
            }
            .el-dialog{
              background: url("../assets/notOpen.png");
              width:350px;
              height:200px;
            }
            .el-button{
              height:30px;
              width:120px;
              line-height:5px;
              font-size:16px;
              font-weight:bold;
            }
            .el-dialog__footer{
              position: absolute;
              left:0;
              right:0;
              bottom: -10px;
            }
            .el-dialog__headerbtn{
              display:none;
            }
            img{
              position: absolute;
              top:15px;
              right:15px
            }
            .text{
              position: absolute;
              left:29%;
              top: 15px;
              font-size:21px;
              font-weight: bold;
            }
          }
        }
        .CppFooter{
          width:775px;
          display: flex;
          justify-content: center;
          margin-top: 20px;
        }
      }
    }
    .upper-conBox {
      padding-top: 30px;
      height: 100%;
      width: 100%;

      .tableBox {
        position: relative;
        width: 51%;
        float: left;
        background: url("~@/assets/images/psn.png") no-repeat;
        background-size: contain;
        height: 335px;

        .logo {
          position: absolute;
          top: 35px;
          left: 35px;
          width: 151px;
          height: 191px;
          background: url("~@/assets/images/logos.png") center / contain
            no-repeat;

          .avatorImg {
            position: absolute;
            top: 14px;
            left: 12px;
            cursor: pointer;
          }

          .titlesVip {
            position: absolute;
            left: 0;
            bottom: 22px;
            width: 100%;
            font-size: 12px;
            text-align: center;
            color: #00ffff;
          }
        }

        .vip {
          background: url("~@/assets/images/vipLogo.png") center / contain
            no-repeat;
        }

        .icode {
          position: absolute;
          top: 58px;
          left: 230px;
          width: 313px;
          height: 47px;
          line-height: 47px;
          text-align: center;
          font-size: 22px;
          font-weight: bold;
          color: #fff;
          cursor: default;
        }
        .vipIcode {
          width: 500px;
          height: 70px;
          position: absolute;
          background: url("~@/assets/images/toVip.png") no-repeat;
          background-size: contain;
          bottom: 25px;
          left: 45px;
          text-align: center;
          line-height: 72px;
          font-size: 28px;
          font-weight: bold;
          color: #3c3f53;
          cursor: pointer;
        }
        .icodeName {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .icodeGrade {
          top: 116px;
        }
        .icodeLevel {
          top: 174px;
        }
      }
      .myInfoBox {
        width: 41%;
        float: right;
        .gameImg {
          background: url("~@/assets/images/steZh.png") no-repeat center;
          background-size: contain;
          height: 310px;
          position: relative;
          .block {
            width: 80%;
            position: absolute;
            top: 100px;
            left: 50%;
            transform: translateX(-50%);
            button[type="button"] {
              display: none !important;
            }
          }
          span {
            line-height: 30px;
            color: #fff;
          }
        }
        .gameImgEn {

          .block {
            width: 84%;
            position: absolute;
            top: 100px;
            left: 50%;
            transform: translateX(-50%);
            button[type="button"] {
              display: none !important;
            }
          }
          span {
            line-height: 30px;
            color: #fff;
          }
        }
        .schoolOfLeapLearner {
          height: 59px;
          background-color: #f3dd47;
          margin: 10px 0;
          font-size: 30px;
          color: #3c3f53;
          line-height: 59px;
          text-align: center;
          font-weight: bold;
        }
        .allMsg {
          width: 100%;
          height: 500px;
          background: url("~@/assets/images/tab01.png") no-repeat center;
          overflow: hidden;
          position: relative;
          .codeTogame {
            position: absolute;
            top: 58px;
            font-size: 24px;
            color: #fff;
            height: 10%;
            width: 32%;
            left: 49px;
            line-height: 50px;
            text-align: center;
            cursor: pointer;
            font-weight: bold;
          }
          .blocklyGame {
            left: 289px;
            i {
              background-color: #f56c6c;
              border-radius: 10px;
              color: #fff;
              display: inline-block;
              font-size: 12px;
              height: 18px;
              line-height: 18px;
              padding: 0 6px;
              text-align: center;
              white-space: nowrap;
              position: absolute;
              top: -8px;
              right: 16px;
            }
          }
          .ul {
            padding: 10px;
            li {
              height: 58px;
              line-height: 58px;
              color: #ffffff;
              font-size: 25px;
              font-weight: bold;
              padding: 0 20px;
            }
          }
          .startGame {
            cursor: pointer;
            width: 232px;
            height: 58px;
            background: url("~@/assets/images/goGame.png") no-repeat center;
            font-size: 28px;
            color: #3c3f53;
            line-height: 58px;
            border: none;
            margin: 0 auto;
            margin-top: 40px;
            display: block;
            font-weight: bold;
            transform: scale(1);
            transition: All 0.5s ease-in-out;
          }
          .startGame:hover {
            transform: scale(1.05);
            transition: All 0.5s ease-in-out;
          }
          .fz {
            font-size: 22px;
          }
        }
        .allMsg1 {
          background: url("~@/assets/images/tab02.png") no-repeat center;
        }
      }
      .isEventBg {
        // 圣诞背景
        background: url("~@/assets/images/event/Christmas2020/index_user_bg.png")
          no-repeat !important;
      }
      .isEventAvatar {
        // 圣诞背景
        background: url("~@/assets/images/event/Christmas2020/index_non-vip.png")
          no-repeat !important;
      }
      .isEventAvatarVip {
        // 圣诞背景
        background: url("~@/assets/images/event/Christmas2020/index_vip.png")
          no-repeat !important;
      }
      .isEventBoard {
        // 圣诞背景
        background: url("~@/assets/images/event/Christmas2020/index_user_toVip.png")
          no-repeat !important;
      }
      .vip_0 {
        // 会员1级背景
        background: url("~@/assets/images/vip_1.png")
          no-repeat !important;
      }
      .vip_10 {
        // 会员1级背景
        background: url("~@/assets/images/vip_2.png")
          no-repeat !important;
      }
      .vip_20 {
        // 会员1级背景
        background: url("~@/assets/images/vip_3.png")
          no-repeat !important;
      }
      .vip_30 {
        // 会员1级背景
        background: url("~@/assets/images/vip_4.png")
          no-repeat !important;
      }
      .vip_40 {
        // 会员1级背景
        background: url("~@/assets/images/vip_5.png")
          no-repeat !important;
      }
      .vip_50 {
        // 会员1级背景
        background: url("~@/assets/images/vip_6.png")
          no-repeat !important;
      }
      .normal_0 {
        // 非会员1级背景
        background: url("~@/assets/images/normal_1.png")
          no-repeat !important;
      }
      .normal_10 {
        // 非会员2级背景
        background: url("~@/assets/images/normal_2.png")
          no-repeat !important;
      }
      .normal_20 {
        // 非会员1级背景
        background: url("~@/assets/images/normal_3.png")
          no-repeat !important;
      }
      .normal_30 {
        // 非会员1级背景
        background: url("~@/assets/images/normal_4.png")
          no-repeat !important;
      }
      .normal_40 {
        // 非会员1级背景
        background: url("~@/assets/images/normal_5.png")
          no-repeat !important;
      }
      .normal_50 {
        // 非会员1级背景
        background: url("~@/assets/images/normal_6.png")
          no-repeat !important;
      }
    }
    .lower-conBox {
      width: 100%;
      height: 100%;
      position: relative;

      .leftIcode {
        width: 220px;
        height: 464px;
        background: url("~@/assets/images/sources.png") no-repeat;
        background-size: contain;
        margin-top: 40px;
        float: left;
        position: relative;
        .icodeTit {
          position: absolute;
          width: 172px;
          height: 46px;
          left: 24px;
          top: 4px;
          font-size: 20px;
          color: #00ffff;
          text-align: center;
          line-height: 40px;
        }
        .arrows {
          width: 200px;
          height: 410px;
          position: absolute;
          top: 50px;
          left: 50%;
          transform: translateX(-50%);
          span {
            width: 38px;
            height: 25px;
            position: absolute;
            top: 10px;
            left: 50%;
            transform: translateX(-50%);
            cursor: pointer;
          }
          .pre {
            background: url("~@/assets/images/topArrow.png") no-repeat;
            background-size: contain;
          }
          .next {
            top: 370px;
            background: url("~@/assets/images/botArrow.png") no-repeat;
            background-size: contain;
          }
        }
        .planets {
          width: 200px;
          height: 320px;
          position: absolute;
          top: 54%;
          left: 50%;
          transform: translate(-50%, -50%);
          overflow: hidden;
          ul {
            width: 100%;
            height: 1000px;
            position: absolute;
            top: 10px;
            li {
              width: 180px;
              height: 160px;
              margin: 0 auto;
              position: relative;
              cursor: pointer;
              transition: All 0.3s ease-in-out;
              z-index: 3;
              &:hover {
                transform: scale(1.15);
              }
              .bgIcon {
                width: 147px;
                height: 147px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: url("~@/assets/images/plantKey.png") no-repeat;
                background-size: contain;
                z-index: 1;
              }
            }
            .planetLisBg {
              opacity: 0.75;
            }
            .planetLiss {
              position: absolute;
              width: 100%;
              height: 100%;
            } 
            .lisBgs {
              position: absolute;
              width: 100%;
              height: 100%;
            }
            .lisBg {
              background: url("~@/assets/images/planet/planetBg1.png") no-repeat;
              background-size: contain;
            }
          }
        }
      }
      .rightIcode {
        width: 932px;
        height: 471px;
        background: url("~@/assets/images/rightIcode.png") no-repeat;
        background-size: contain;
        margin-top: 40px;
        float: right;
        position: relative;

        .tipsIcode {
          position: absolute;
          top: 50px;
          left: 50%;
          width: 771px;
          height: 58px;
          line-height: 52px;
          text-align: center;
          background: url("~@/assets/images/tipsIcode.png") center / contain
            no-repeat;
          transform: translateX(-50%);
          font-size: 32px;
          font-weight: bold;
          color: #00ffff;
        }

        .course {
          position: absolute;
          top: 140px;
          left: 50%;
          width: 745px;
          height: 231px;
          transform: translateX(-50%);
          overflow: hidden;

          ul {
            width: 20000px;
            height: 100%;
            position: absolute;
            top: 0px;
            left: 0px;

            li {
              position: relative;
              float: left;
              width: 170px;
              height: 231px;
              margin: 0 auto;
              margin-left: 14px;
              background: url("~@/assets/images/course.png") no-repeat;
              background-size: contain;

              // 活动
              // &:first-child {
              //   background: url("~@/assets/images/course-2020Helloween.png") no-repeat;

              //   .courseTitle:first-child {
              //     color: #333;
              //     font-weight: bold;
              //   }
              // }

              .bgIcon {
                width: 175px;
                height: 230px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: url("~@/assets/images/courseIcon.png") no-repeat;
                background-size: contain;
                z-index: 1;
                &:hover .btnIcon {
                  opacity: 1;
                }
                .btnIcon {
                  width: 175px;
                  height: 175px;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  background: red;
                  opacity: 0;
                  transition: All 0.5s ease-in-out;
                }
              }
              .courseTitle {
                width: 169px;
                height: 55px;
                position: absolute;
                top: 0;
                left: 1px;
                text-align: center;
                line-height: 55px;
                color: #00ffff;
                font-size: 18px;
              }
              .courseImg {
                width: 105px;
                height: 72px;
                background-size: contain;
                position: absolute;
                top: 66px;
                left: 50%;
                transform: translateX(-50%);
              }

              // .courseImg1 {
              //   background: url("~@/assets/images/course/couseImg1.png")
              //     no-repeat;
              //   background-size: contain;
              // }
              // .courseImg2 {
              //   background: url("~@/assets/images/course/couseImg2.png")
              //     no-repeat;
              //   background-size: contain;
              // }
              // .courseImg3 {
              //   background: url("~@/assets/images/course/couseImg3.png")
              //     no-repeat;
              //   background-size: contain;
              // }
              // .courseImg4 {
              //   background: url("~@/assets/images/course/couseImg4.png")
              //     no-repeat;
              //   background-size: contain;
              // }

              .courseScorce {
                position: absolute;
                bottom: 63px;
                right: 37px;
                font-size: 20px;
                color: #fff;
              }
              .courseStart {
                position: absolute;
                bottom: 0;
                left: 5px;
                width: 166px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                color: #3c3f53;
                font-size: 20px;
                font-weight: bold;
                background: url("~@/assets/images/courseBtn.png") no-repeat;
                background-size: contain;
                cursor: pointer;
                &:hover {
                  animation: firstdiv 0.7s ease-in-out 0.3s infinite alternate;
                }
                &__blocky {
                  background-image: url("~@/assets/images/blocky-btn.png");
                }
              }

              .courseBtnVip {
                background: url("~@/assets/images/courseBtnVip.png") no-repeat;
                background-size: contain;
                &__blocky {
                  background-image: url("~@/assets/images/blocky-btn-vip.png");
                }
              }
            }
            .courseLisVip {
              background: url("~@/assets/images/courseVip.png") no-repeat;
              background-size: contain;
            }
            .planetLisBg {
              opacity: 0.43;
            }
          }

          .eventCourse {
            background-image: url("~@/assets/images/event/Helloween2020/course-2020Helloween.png");

            .courseTitle {
              color: #000;
              font-weight: bold;
            }

            .eventBtn {
              background-image: url("~@/assets/images/event/Helloween2020/course-2020Helloween-btn.png");
              transition: 0.3s ease-in-out;

              &:hover {
                background-image: url("~@/assets/images/event/Helloween2020/course-2020Helloween-btn-hover.png");
                color: #fff;
              }
            }
          }

          .noCourseTxt {
            color: #00ffff;
            font-size: 28px;
            text-align: center;
            line-height: 35px;
            padding-top: 80px;
          }
        }
        @keyframes firstdiv {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }
        .learnMsg {
          position: absolute;
          width: 745px;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%);
          height: 40px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          .progressBar {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: center;
            width: 500px;
            position: relative;


            .progressStarMain {
              position: absolute;
              margin-left: 50px;
              left: 0;
              top: 0;
              height: 40px;
              width: 450px;
            }
            .progressStar {
              position: absolute;
              top: -8px;
              left: 20%;
              width: 30px;
              height: 34px;
              background: url("~@/assets/images/unlockStarIcon.png") center /
                cover no-repeat;
              transition: 0.4s ease-in-out all;
              transform: translateX(-50%);
              z-index: 10;
              cursor: pointer;
            }
            .progressMsg {
              position: absolute;
              top: -23px;
              left: 0;
              width: 400px;
              height: 20px;
              font: 14px bold;
              color: #fff;
              transform: translateX(-45%);
              text-align: center;
              cursor: default;
            }

            .el-progress {
              width: 450px;

              &::before {
                content: "";
                position: absolute;
                top: -10px;
                left: 0px;
                width: 40px;
                height: 40px;
                background: url("~@/assets/images/progress-i.png") center /
                  cover no-repeat;
                z-index: 10;
              }
              .el-progress-bar {
                padding-right: 0;
                margin-right: 0;
              }
              .el-progress-bar__outer {
                height: 18px !important;
                background-color: #1e5a85;
                border: 2px solid #00cfd3;
              }
              .el-progress-bar__inner {
                background: linear-gradient(180deg, #0ff, #0a7ba0);
              }
              .el-progress__text {
                display: none;
              }
            }
          }
            .progress_txt {
              display: block;
              width: 100px;
              height: 22px;
              font-size: 16px;
              font-weight: bold;
              color: #0ff;
              text-align: center;
            }
            .raceGoBtn {
              width: max-content;
              span {
                width: max-content;
                font: 22px bold;
                color: #ffee00;
                background: transparent;
                transition: 0.4s ease all;
                cursor: pointer;
                text-decoration: underline;

                &:hover {
                  color: #1c9feb;
                }
              }
            }
        }
        .allArrows {
          width: 25px;
          height: 38px;
          position: absolute;
          top: 55%;
          transform: translateY(-50%);
          cursor: pointer;
        }
        .preIcode {
          background: url("~@/assets/images/lArrow.png") no-repeat;
          background-size: contain;
          left: 70px;
        }
        .nextIcode {
          background: url("~@/assets/images/rArrow.png") no-repeat;
          background-size: contain;
          right: 70px;
        }
      }
    }
  }

  .mainBoxWrapper {
    min-height: calc(100vh - 60px);
  }

  .courseTitleVip {
    color: #ffec44 !important;
  }

  .chooseMode {
    background: url("~@/assets/images/bg.jpg") center / cover no-repeat;
    .el-dialog {
      background: unset;
      box-shadow: unset;
      margin-top: 10vh !important;

      .container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;

        .title {
          width: 100%;
          color: #0ff;
          font-size: 20px;
          line-height: 50px;
          margin-bottom: 20px;
          background: url("~@/assets/images/tips.png") center / contain no-repeat;
        }

        .tip {
          font-size: 16px;
          margin: 2em 0 5em 0;
          color: #fff;

          b {
            line-height: 40px;
          }
        }

        .btn {
          // width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          align-items: center;
          .btn-blocky,
          .btn-python {
            width: 350px;
            height: 340px;
            cursor: pointer;
            display: inline-block;
          }

          .btn-playInstruction,
          .btn-closeInstruction {
            width: 350px;
            height: 80px;
            padding-bottom: 10px;

            cursor: pointer;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            span {
              color: white;
              font-size: large;
              font-weight: bolder;
            }
          }

          &-playInstruction {
            position: relative;
            margin: 0 20px;
            background: url("~@/assets/images/OKBtn.png") center /
              contain no-repeat;
            &:hover {
              animation: textAction 0.5s linear infinite;
            }
          }

          &-closeInstruction {
            background: url("~@/assets/images/CancelBtn.png") center /
              contain no-repeat;
            &:hover {
              animation: textAction 0.5s linear infinite;
            }
          }

          .btn_text {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;

            .btn-blocky__text,
            .btn-python__text {
              display: inline-block;
              width: 350px;
              font: 1.2rem bold;
              color: #fff;
            }
          }
        }
      }
    }
  }

  .unlockTrain {
    .el-dialog {
      background: unset;

      .container {
        box-sizing: border-box;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        width: 600px;
        height: 342px;
        background: url("~@/assets/images/unlockNewLevel.png") center / contain
          no-repeat;

        .title {
          width: 85%;
          color: #ff1;
          font-size: 30px;
          line-height: 60px;
          margin-bottom: 20px;
        }

        .tip {
          font-size: 20px;
          margin: 2em 0 2em 0;
          color: #ff1;
        }

        .closeBtn {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 48px;
          height: 49px;
          cursor: pointer;
          background: url("~@/assets/images/unlockbtn.png") 50% no-repeat;
        }
      }
    }
  }

  .clearfix {
    content: "";
    display: block;
    clear: both;
  }

  .opacity {
    opacity: 0.3;
  }

  .el-loading-mask {
    z-index: 1;
  }

  .videoWrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 9999;

    video {
      width: 100%;
      height: 100%;
    }
    .btn {
      position: fixed;
      right: 20px;
      top: 20px;
      cursor: pointer;
      opacity: 0.5;
      transition: 0.4s ease all;
      &:hover {
        opacity: 1;
      }
    }
  }
}
.backgroundColor{
  background-color: #F6F5FA;
}

// 多语言模块
.zh {
  .planetLis1 {
    background: url("~@/assets/images/planet/planet1.png") no-repeat;
    background-size: contain;
  }
  .planetLis2 {
    background: url("~@/assets/images/planet/planet2.png") no-repeat;
    background-size: contain;
  }
  .planetLis3 {
    background: url("~@/assets/images/planet/planet3.png") no-repeat;
    background-size: contain;
  }
  .planetLis4 {
    background: url("~@/assets/images/planet/planet4.png") no-repeat;
    background-size: contain;
  }
  .planetLis5 {
    background: url("~@/assets/images/planet/planet5.png") no-repeat;
    background-size: contain;
  }
  .planetLis6 {
    background: url("~@/assets/images/planet/planet6.png") no-repeat;
    background-size: contain;
  }

  .gameImgEn {
    background: url("~@/assets/images/steEn.png") no-repeat center;
    background-size: contain;
    height: 310px;
    position: relative;
  }

  .btn-blocky {
    position: relative;
    margin: 0 20px;
    background: url("~@/assets/images/freshman-blocky.png") center /
      contain no-repeat;
    &:hover {
      background-image: url("~@/assets/images/freshman-blocky-hover.png");
    }
  }

  .btn-python {
    background: url("~@/assets/images/freshman-python.png") center /
      contain no-repeat;
    &:hover {
      background-image: url("~@/assets/images/freshman-python-hover.png");
    }
  }
}

.en {
  .planetLis1 {
    background: url("~@/assets/images/planet/planetEn1.png") no-repeat;
    background-size: contain;
  }
  .planetLis2 {
    background: url("~@/assets/images/planet/planetEn2.png") no-repeat;
    background-size: contain;
  }
  .planetLis3 {
    background: url("~@/assets/images/planet/planetEn3.png") no-repeat;
    background-size: contain;
  }
  .planetLis4 {
    background: url("~@/assets/images/planet/planetEn4.png") no-repeat;
    background-size: contain;
  }
  .planetLis5 {
    background: url("~@/assets/images/planet/planetEn5.png") no-repeat;
    background-size: contain;
  }
  .planetLis6 {
    background: url("~@/assets/images/planet/planetEn6.png") no-repeat;
    background-size: contain;
  }

  .el-carousel {
    text-align: center;
    span {
      font-size: 16px;
    }
  }

  .gameImgEn {
    background: url("~@/assets/images/steEn.png") no-repeat center;
    background-size: contain;
    height: 310px;
    position: relative;
  }

  .btn-blocky {
    margin: 0 20px;
    background: url("~@/assets/images/freshman-blocky__en.png") center /
      contain no-repeat;
    &:hover {
      background-image: url("~@/assets/images/freshman-blocky__en-hover.png");
    }
  }

  .btn-python  {
    margin-right: 40px;
    background: url("~@/assets/images/freshman-python__en.png") center /
      contain no-repeat;
    &:hover {
      background-image: url("~@/assets/images/freshman-python__en-hover.png");
    }
  }

}

.he {
  .gameImgEn {
    background: url("~@/assets/images/he/desk.png") no-repeat center;
    background-size: contain;
    height: 310px;
    position: relative;
  }
  .planetLis1 {
    background: url("~@/assets/images/he/planet/planet1.png") no-repeat;
    background-size: contain;
  }
  .planetLis2 {
    background: url("~@/assets/images/he/planet/planet2.png") no-repeat;
    background-size: contain;
  }
  .planetLis3 {
    background: url("~@/assets/images/he/planet/planet3.png") no-repeat;
    background-size: contain;
  }
  .planetLis4 {
    background: url("~@/assets/images/he/planet/planet4.png") no-repeat;
    background-size: contain;
  }
  .planetLis5 {
    background: url("~@/assets/images/he/planet/planet5.png") no-repeat;
    background-size: contain;
  }
  .planetLis6 {
    background: url("~@/assets/images/he/planet/planet6.png") no-repeat;
    background-size: contain;
  }

  .el-carousel {
    text-align: center;
    span {
      font-size: 16px;
    }
  }

  .btn-blocky {
    margin: 0 20px;
    background: url("~@/assets/images/he/freshman-blocky.png") center /
      contain no-repeat;
    &:hover {
      background-image: url("~@/assets/images/he/freshman-blocky-hover.png");
    }
  }

  .btn-python {
    margin-right: 40px;
    background: url("~@/assets/images/he/freshman-python.png") center /
      contain no-repeat;
    &:hover {
      background-image: url("~@/assets/images/he/freshman-python-hover.png");
    }
  } 
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue